/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: { input: string; output: string };
    String: { input: string; output: string };
    Boolean: { input: boolean; output: boolean };
    Int: { input: number; output: number };
    Float: { input: number; output: number };
    /** The `Date` scalar represents an ISO-8601 compliant date type. */
    Date: { input: string; output: string };
    /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
    DateTime: { input: string; output: string };
    /** The `Decimal` scalar type represents a decimal floating-point number. */
    Decimal: { input: any; output: any };
    /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
    Long: { input: number; output: number };
    UUID: { input: string; output: string };
};

export type AddGuestRelationResult = {
    __typename?: 'AddGuestRelationResult';
    success: Scalars['Boolean']['output'];
};

export type Amount = {
    __typename?: 'Amount';
    currencyCode: Scalars['String']['output'];
    grossAmount?: Maybe<Scalars['Decimal']['output']>;
    netAmount: Scalars['Decimal']['output'];
};

export type Analytics = {
    __typename?: 'Analytics';
    lastStayDate?: Maybe<Scalars['String']['output']>;
    totalAmountSpent?: Maybe<Amount>;
    totalNightsSpent?: Maybe<Scalars['Int']['output']>;
    totalStays?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsTotalAmountSpentArgs = {
    currency: Scalars['String']['input'];
};

/** Defines when a policy shall be executed. */
export enum ApplyPolicy {
    /** After the resolver was executed. */
    AfterResolver = 'AFTER_RESOLVER',
    /** Before the resolver was executed. */
    BeforeResolver = 'BEFORE_RESOLVER',
    /** The policy is applied in the validation step before the execution. */
    Validation = 'VALIDATION',
}

export type DeclineMatchResult = {
    __typename?: 'DeclineMatchResult';
    success: Scalars['Boolean']['output'];
};

export type DeleteGuestPhotoResult = {
    __typename?: 'DeleteGuestPhotoResult';
    success: Scalars['Boolean']['output'];
};

export type DeleteIdentityDocumentPhotoResult = {
    __typename?: 'DeleteIdentityDocumentPhotoResult';
    success: Scalars['Boolean']['output'];
};

export enum DisplayField {
    AccountingCode = 'AccountingCode',
    BillingCode = 'BillingCode',
    BirthDate = 'BirthDate',
    BirthPlace = 'BirthPlace',
    CarRegistrationNumber = 'CarRegistrationNumber',
    DietaryRequirements = 'DietaryRequirements',
    Email = 'Email',
    FirstName = 'FirstName',
    LastName = 'LastName',
    LoyaltyCode = 'LoyaltyCode',
    LoyaltyMembership = 'LoyaltyMembership',
    NationalityCode = 'NationalityCode',
    Occupation = 'Occupation',
    Phone = 'Phone',
    PreferredLanguageCode = 'PreferredLanguageCode',
    SecondLastName = 'SecondLastName',
    Sex = 'Sex',
    TaxIdentifier = 'TaxIdentifier',
    TitlePrefix = 'TitlePrefix',
}

export type GuestMatch = {
    __typename?: 'GuestMatch';
    guest1Id: Scalars['UUID']['output'];
    guest2Id: Scalars['UUID']['output'];
    id: Scalars['String']['output'];
};

export type GuestMergeInfo = {
    __typename?: 'GuestMergeInfo';
    errorMessage: Scalars['String']['output'];
    isMergePossible: Scalars['Boolean']['output'];
};

export type GuestPhoto = {
    __typename?: 'GuestPhoto';
    createdUtc: Scalars['DateTime']['output'];
    guestId: Scalars['UUID']['output'];
    id: Scalars['UUID']['output'];
    imageUrl: Scalars['String']['output'];
    name: Scalars['String']['output'];
};

export type GuestProfile = {
    __typename?: 'GuestProfile';
    accountingCode?: Maybe<Scalars['String']['output']>;
    billingCode?: Maybe<Scalars['String']['output']>;
    birthDate?: Maybe<Scalars['Date']['output']>;
    birthPlace?: Maybe<Scalars['String']['output']>;
    carRegistrationNumber?: Maybe<Scalars['String']['output']>;
    createdUtc: Scalars['DateTime']['output'];
    dietaryRequirements?: Maybe<Scalars['String']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    fullName: Scalars['String']['output'];
    id: Scalars['UUID']['output'];
    imageId?: Maybe<Scalars['UUID']['output']>;
    lastName: Scalars['String']['output'];
    loyaltyCode?: Maybe<Scalars['String']['output']>;
    loyaltyMembership?: Maybe<Membership>;
    nationalityCode?: Maybe<Scalars['String']['output']>;
    number: Scalars['Long']['output'];
    occupation?: Maybe<Scalars['String']['output']>;
    paymentCard?: Maybe<PaymentCard>;
    phone?: Maybe<Scalars['String']['output']>;
    preferredLanguageCode?: Maybe<Scalars['String']['output']>;
    secondLastName?: Maybe<Scalars['String']['output']>;
    sex?: Maybe<Sex>;
    taxIdentifier?: Maybe<Scalars['String']['output']>;
    titlePrefix?: Maybe<TitlePrefix>;
    updatedUtc: Scalars['DateTime']['output'];
};

export type GuestProfileClassifications = {
    __typename?: 'GuestProfileClassifications';
    airline: Scalars['Boolean']['output'];
    blacklist: Scalars['Boolean']['output'];
    cashlist: Scalars['Boolean']['output'];
    disabledPerson: Scalars['Boolean']['output'];
    friendOrFamily: Scalars['Boolean']['output'];
    healthCompliant: Scalars['Boolean']['output'];
    important: Scalars['Boolean']['output'];
    inRoom: Scalars['Boolean']['output'];
    loyaltyProgram: Scalars['Boolean']['output'];
    media: Scalars['Boolean']['output'];
    military: Scalars['Boolean']['output'];
    paymasterAccount: Scalars['Boolean']['output'];
    previousComplaint: Scalars['Boolean']['output'];
    problematic: Scalars['Boolean']['output'];
    returning: Scalars['Boolean']['output'];
    staff: Scalars['Boolean']['output'];
    student: Scalars['Boolean']['output'];
    topManagement: Scalars['Boolean']['output'];
    veryImportant: Scalars['Boolean']['output'];
    waitingForRoom: Scalars['Boolean']['output'];
};

export type GuestProfileMergeUpdatesInput = {
    accountingCode?: InputMaybe<UpdateNullableValueOfStringInput>;
    billingCode?: InputMaybe<UpdateNullableValueOfStringInput>;
    birthDate?: InputMaybe<UpdateNullableValueOfNullableOfDateOnlyInput>;
    birthPlace?: InputMaybe<UpdateNullableValueOfStringInput>;
    carRegistrationNumber?: InputMaybe<UpdateNullableValueOfStringInput>;
    companyId?: InputMaybe<UpdateNullableValueOfNullableOfGuidInput>;
    dietaryRequirements?: InputMaybe<UpdateNullableValueOfStringInput>;
    email?: InputMaybe<UpdateNullableValueOfStringInput>;
    firstName?: InputMaybe<UpdateNullableValueOfStringInput>;
    lastName?: InputMaybe<UpdateValueOfStringInput>;
    loyaltyCode?: InputMaybe<UpdateNullableValueOfStringInput>;
    loyaltyMembershipId?: InputMaybe<UpdateValueOfGuidInput>;
    nationalityCode?: InputMaybe<UpdateNullableValueOfStringInput>;
    occupation?: InputMaybe<UpdateNullableValueOfStringInput>;
    phone?: InputMaybe<UpdateNullableValueOfStringInput>;
    preferredLanguageCode?: InputMaybe<UpdateNullableValueOfStringInput>;
    secondLastName?: InputMaybe<UpdateNullableValueOfStringInput>;
    sex?: InputMaybe<UpdateNullableValueOfNullableOfSexInput>;
    taxIdentifier?: InputMaybe<UpdateNullableValueOfStringInput>;
    titlePrefix?: InputMaybe<UpdateNullableValueOfNullableOfTitlePrefixInput>;
};

export enum GuestRelationship {
    Child = 'Child',
    Colleague = 'Colleague',
    Friend = 'Friend',
    Other = 'Other',
    OtherFamily = 'OtherFamily',
    Parent = 'Parent',
    Spouse = 'Spouse',
}

export enum GuestRelationshipSource {
    Guest = 'Guest',
    Staff = 'Staff',
}

export type GuestRelationships = {
    __typename?: 'GuestRelationships';
    guest: GuestProfile;
    relatedGuests: Array<RelatedGuestDetails>;
    suggestedRelations: Array<SuggestedRelation>;
};

export type GuestSummary = IGuestSummary & {
    __typename?: 'GuestSummary';
    analytics: Analytics;
    classifications: GuestProfileClassifications;
    guestId: Scalars['UUID']['output'];
    loyaltyMemberships: Array<Membership>;
    profile: GuestProfile;
    reservations: Array<ReservationSummary>;
};

export type IGuestSummary = {
    analytics: Analytics;
    classifications: GuestProfileClassifications;
    guestId: Scalars['UUID']['output'];
    loyaltyMemberships: Array<Membership>;
    profile: GuestProfile;
    reservations: Array<ReservationSummary>;
};

export enum MatchConfidence {
    High = 'High',
    Low = 'Low',
    Medium = 'Medium',
    VeryLow = 'VeryLow',
}

export enum MatchField {
    BirthDate = 'BirthDate',
    Email = 'Email',
    FirstName = 'FirstName',
    LastName = 'LastName',
    PaymentCard = 'PaymentCard',
    Phone = 'Phone',
    SecondLastName = 'SecondLastName',
}

export type MatchedGuestProfiles = {
    __typename?: 'MatchedGuestProfiles';
    confidence: MatchConfidence;
    id: Scalars['UUID']['output'];
    matchedFields: Array<MatchField>;
    mergeInfo: GuestMergeInfo;
    preSelectedFields: Array<PreSelectedField>;
    profiles: Array<GuestProfile>;
};

/** A connection to a list of items. */
export type MatchedGuestProfilesConnection = {
    __typename?: 'MatchedGuestProfilesConnection';
    /** A list of edges. */
    edges?: Maybe<Array<MatchedGuestProfilesEdge>>;
    /** A flattened list of the nodes. */
    nodes?: Maybe<Array<GuestMatch>>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
    /** Identifies the total count of items in the connection. */
    totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MatchedGuestProfilesEdge = {
    __typename?: 'MatchedGuestProfilesEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: GuestMatch;
};

export type Membership = {
    __typename?: 'Membership';
    code?: Maybe<Scalars['String']['output']>;
    createdUtc: Scalars['DateTime']['output'];
    expirationDate?: Maybe<Scalars['Date']['output']>;
    id: Scalars['UUID']['output'];
    isPrimary: Scalars['Boolean']['output'];
    points?: Maybe<Scalars['Int']['output']>;
    program: Program;
    state: MembershipState;
    tier?: Maybe<Tier>;
    updatedUtc: Scalars['DateTime']['output'];
    url?: Maybe<Scalars['String']['output']>;
};

export enum MembershipState {
    Canceled = 'Canceled',
    Declined = 'Declined',
    Enrolled = 'Enrolled',
    New = 'New',
    Pending = 'Pending',
}

export type MergeResult = {
    __typename?: 'MergeResult';
    success: Scalars['Boolean']['output'];
};

export type Mutations = {
    __typename?: 'Mutations';
    addGuestRelation: AddGuestRelationResult;
    declineMatch: DeclineMatchResult;
    deleteGuestPhoto: DeleteGuestPhotoResult;
    deleteIdentityDocumentPhoto: DeleteIdentityDocumentPhotoResult;
    mergeGuestProfiles: MergeResult;
    removeGuestRelation: RemoveGuestRelationResult;
    updateGuestRelation: UpdateGuestRelationResult;
};

export type MutationsAddGuestRelationArgs = {
    guestId: Scalars['UUID']['input'];
    relatedGuestId: Scalars['UUID']['input'];
    relationship: GuestRelationship;
    source?: InputMaybe<GuestRelationshipSource>;
};

export type MutationsDeclineMatchArgs = {
    guest1Id: Scalars['UUID']['input'];
    guest2Id: Scalars['UUID']['input'];
};

export type MutationsDeleteGuestPhotoArgs = {
    guestId: Scalars['UUID']['input'];
    photoId: Scalars['UUID']['input'];
};

export type MutationsDeleteIdentityDocumentPhotoArgs = {
    guestId: Scalars['UUID']['input'];
    id: Scalars['UUID']['input'];
    identityDocumentId: Scalars['UUID']['input'];
};

export type MutationsMergeGuestProfilesArgs = {
    guestProfileDetails?: InputMaybe<GuestProfileMergeUpdatesInput>;
    matchId?: InputMaybe<Scalars['UUID']['input']>;
    sourceId: Scalars['UUID']['input'];
    targetId: Scalars['UUID']['input'];
};

export type MutationsRemoveGuestRelationArgs = {
    id: Scalars['UUID']['input'];
};

export type MutationsUpdateGuestRelationArgs = {
    id: Scalars['UUID']['input'];
    relationship: GuestRelationship;
};

/** Information about pagination in a connection. */
export type PageInfo = {
    __typename?: 'PageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor?: Maybe<Scalars['String']['output']>;
    /** Indicates whether more edges exist following the set defined by the clients arguments. */
    hasNextPage: Scalars['Boolean']['output'];
    /** Indicates whether more edges exist prior the set defined by the clients arguments. */
    hasPreviousPage: Scalars['Boolean']['output'];
    /** When paginating backwards, the cursor to continue. */
    startCursor?: Maybe<Scalars['String']['output']>;
};

export type PaymentCard = {
    __typename?: 'PaymentCard';
    lastDigits: Scalars['String']['output'];
    type: PaymentCardType;
};

export enum PaymentCardType {
    Amex = 'Amex',
    Bancomat = 'Bancomat',
    Bancontact = 'Bancontact',
    Bc = 'Bc',
    CarteBleue = 'CarteBleue',
    Dankort = 'Dankort',
    DinersClub = 'DinersClub',
    Discover = 'Discover',
    Eftpos = 'Eftpos',
    Eps = 'Eps',
    Giro = 'Giro',
    Interac = 'Interac',
    Isracard = 'Isracard',
    Jcb = 'Jcb',
    Maestro = 'Maestro',
    MasterCard = 'MasterCard',
    Meps = 'Meps',
    Mir = 'Mir',
    Nets = 'Nets',
    PostFinance = 'PostFinance',
    RuPay = 'RuPay',
    Troy = 'Troy',
    UnionPay = 'UnionPay',
    VPay = 'VPay',
    Verve = 'Verve',
    Visa = 'Visa',
}

export type PreSelectedField = {
    __typename?: 'PreSelectedField';
    field: DisplayField;
    profileId: Scalars['UUID']['output'];
};

export type Program = {
    __typename?: 'Program';
    chainId: Scalars['UUID']['output'];
    code: Scalars['String']['output'];
    createdUtc: Scalars['DateTime']['output'];
    id: Scalars['UUID']['output'];
    name: Scalars['String']['output'];
    subscription: ProgramSubscription;
    type: ProgramType;
    updatedUtc: Scalars['DateTime']['output'];
};

export enum ProgramSubscription {
    Free = 'Free',
    Paid = 'Paid',
}

export enum ProgramType {
    ExternalPartner = 'ExternalPartner',
    Hotel = 'Hotel',
    SoftBrand = 'SoftBrand',
    Unknown = 'Unknown',
}

export type Queries = {
    __typename?: 'Queries';
    guestPhotos: Array<GuestPhoto>;
    guestRelationships: GuestRelationships;
    guestSummaryById: IGuestSummary;
    guestSummaryByIds: Array<Maybe<GuestSummary>>;
    matchedGuestProfiles?: Maybe<MatchedGuestProfilesConnection>;
    matchedGuestProfilesById: MatchedGuestProfiles;
    nextMatchedGuestProfiles?: Maybe<MatchedGuestProfiles>;
    totalProfileMatches: TotalProfileMatches;
};

export type QueriesGuestPhotosArgs = {
    guestIds: Array<Scalars['UUID']['input']>;
};

export type QueriesGuestRelationshipsArgs = {
    guestId: Scalars['UUID']['input'];
};

export type QueriesGuestSummaryByIdArgs = {
    guestId: Scalars['UUID']['input'];
};

export type QueriesGuestSummaryByIdsArgs = {
    guestIds: Array<Scalars['UUID']['input']>;
};

export type QueriesMatchedGuestProfilesArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    chainId: Scalars['UUID']['input'];
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueriesMatchedGuestProfilesByIdArgs = {
    guestIds: Array<Scalars['UUID']['input']>;
};

export type QueriesNextMatchedGuestProfilesArgs = {
    chainId: Scalars['UUID']['input'];
    previousMatchId?: InputMaybe<Scalars['UUID']['input']>;
};

export type QueriesTotalProfileMatchesArgs = {
    chainId: Scalars['UUID']['input'];
};

export type RelatedGuestDetails = {
    __typename?: 'RelatedGuestDetails';
    fullName: Scalars['String']['output'];
    guestId: Scalars['UUID']['output'];
    id: Scalars['UUID']['output'];
    nextStayDate?: Maybe<Scalars['Date']['output']>;
    nextStayReservationId?: Maybe<Scalars['UUID']['output']>;
    previousStayCount: Scalars['Int']['output'];
    relationship: GuestRelationship;
    source: GuestRelationshipSource;
};

export type RemoveGuestRelationResult = {
    __typename?: 'RemoveGuestRelationResult';
    success: Scalars['Boolean']['output'];
};

export enum ReservationAccountState {
    Booker = 'Booker',
    Companion = 'Companion',
    Owner = 'Owner',
}

export type ReservationOptions = {
    __typename?: 'ReservationOptions';
    allCompanionsCheckedIn: Scalars['Boolean']['output'];
    anyCompanionCheckedIn: Scalars['Boolean']['output'];
    ownerCheckedIn: Scalars['Boolean']['output'];
    ownerCheckedOut: Scalars['Boolean']['output'];
    skipCleaning: Scalars['Boolean']['output'];
};

export type ReservationResourceSummary = {
    __typename?: 'ReservationResourceSummary';
    id: Scalars['UUID']['output'];
    name?: Maybe<Scalars['String']['output']>;
    state: ResourceState;
};

export enum ReservationState {
    Active = 'Active',
    Canceled = 'Canceled',
    Past = 'Past',
}

export type ReservationSummary = {
    __typename?: 'ReservationSummary';
    accountState: ReservationAccountState;
    endLocalTime: Scalars['DateTime']['output'];
    endUtc: Scalars['DateTime']['output'];
    groupName: Scalars['String']['output'];
    id: Scalars['UUID']['output'];
    number?: Maybe<Scalars['String']['output']>;
    options: ReservationOptions;
    reservationState: ReservationState;
    resource?: Maybe<ReservationResourceSummary>;
    serviceId: Scalars['UUID']['output'];
    serviceOrderState: ServiceOrderState;
    startLocalTime: Scalars['DateTime']['output'];
    startUtc: Scalars['DateTime']['output'];
    timeState: ReservationTimeState;
};

export enum ReservationTimeState {
    CheckInMissed = 'CheckInMissed',
    CheckOutMissed = 'CheckOutMissed',
    CheckedIn = 'CheckedIn',
    ConfirmationMissed = 'ConfirmationMissed',
    Future = 'Future',
    Past = 'Past',
    ToBeCheckedIn = 'ToBeCheckedIn',
    ToBeCheckedOut = 'ToBeCheckedOut',
    ToBeConfirmed = 'ToBeConfirmed',
}

export enum ResourceState {
    Clean = 'Clean',
    Dirty = 'Dirty',
    Inspected = 'Inspected',
    OutOfOrder = 'OutOfOrder',
    OutOfService = 'OutOfService',
}

export enum ServiceOrderState {
    Canceled = 'Canceled',
    Confirmed = 'Confirmed',
    Inquired = 'Inquired',
    Optional = 'Optional',
    Processed = 'Processed',
    Requested = 'Requested',
    Started = 'Started',
    Unknown = 'Unknown',
}

export enum Sex {
    Female = 'Female',
    Male = 'Male',
}

export type SuggestedRelation = {
    __typename?: 'SuggestedRelation';
    fullName: Scalars['String']['output'];
    guestId: Scalars['UUID']['output'];
    nextStayDate?: Maybe<Scalars['Date']['output']>;
    nextStayReservationId?: Maybe<Scalars['UUID']['output']>;
    previousStayCount: Scalars['Int']['output'];
};

export type Tier = {
    __typename?: 'Tier';
    code: Scalars['String']['output'];
    createdUtc: Scalars['DateTime']['output'];
    id: Scalars['UUID']['output'];
    name: Scalars['String']['output'];
    ordering: Scalars['Int']['output'];
    programId: Scalars['UUID']['output'];
    updatedUtc: Scalars['DateTime']['output'];
};

export enum TitlePrefix {
    Doctor = 'Doctor',
    Miss = 'Miss',
    Mister = 'Mister',
    Mrs = 'Mrs',
    Professor = 'Professor',
}

export type TotalProfileMatches = {
    __typename?: 'TotalProfileMatches';
    total: Scalars['Int']['output'];
};

export type UpdateGuestRelationResult = {
    __typename?: 'UpdateGuestRelationResult';
    success: Scalars['Boolean']['output'];
};

export type UpdateNullableValueOfNullableOfDateOnlyInput = {
    value?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateNullableValueOfNullableOfGuidInput = {
    value?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateNullableValueOfNullableOfSexInput = {
    value?: InputMaybe<Sex>;
};

export type UpdateNullableValueOfNullableOfTitlePrefixInput = {
    value?: InputMaybe<TitlePrefix>;
};

export type UpdateNullableValueOfStringInput = {
    value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateValueOfGuidInput = {
    value: Scalars['UUID']['input'];
};

export type UpdateValueOfStringInput = {
    value: Scalars['String']['input'];
};

export type LoyaltyMembershipBasicFieldsFragment = {
    __typename?: 'Membership';
    code?: string | null;
    createdUtc: string;
    id: string;
    isPrimary: boolean;
    state: MembershipState;
    updatedUtc: string;
    program: { __typename?: 'Program' } & {
        ' $fragmentRefs'?: { LoyaltyProgramFieldsFragment: LoyaltyProgramFieldsFragment };
    };
} & { ' $fragmentName'?: 'LoyaltyMembershipBasicFieldsFragment' };

export type ClassificationFieldsFragment = {
    __typename?: 'GuestProfileClassifications';
    airline: boolean;
    blacklist: boolean;
    cashlist: boolean;
    disabledPerson: boolean;
    friendOrFamily: boolean;
    healthCompliant: boolean;
    important: boolean;
    inRoom: boolean;
    loyaltyProgram: boolean;
    media: boolean;
    military: boolean;
    paymasterAccount: boolean;
    previousComplaint: boolean;
    problematic: boolean;
    returning: boolean;
    staff: boolean;
    student: boolean;
    topManagement: boolean;
    veryImportant: boolean;
    waitingForRoom: boolean;
} & { ' $fragmentName'?: 'ClassificationFieldsFragment' };

export type ReservationSummaryFieldsFragment = {
    __typename?: 'ReservationSummary';
    accountState: ReservationAccountState;
    endUtc: string;
    groupName: string;
    id: string;
    serviceId: string;
    number?: string | null;
    reservationState: ReservationState;
    serviceOrderState: ServiceOrderState;
    startLocalTime: string;
    endLocalTime: string;
    startUtc: string;
    timeState: ReservationTimeState;
    options: {
        __typename?: 'ReservationOptions';
        allCompanionsCheckedIn: boolean;
        anyCompanionCheckedIn: boolean;
        ownerCheckedIn: boolean;
        ownerCheckedOut: boolean;
        skipCleaning: boolean;
    };
    resource?: {
        __typename?: 'ReservationResourceSummary';
        id: string;
        name?: string | null;
        state: ResourceState;
    } | null;
} & { ' $fragmentName'?: 'ReservationSummaryFieldsFragment' };

export type LoyaltyMembershipSummaryFieldsFragment = {
    __typename?: 'Membership';
    code?: string | null;
    createdUtc: string;
    id: string;
    isPrimary: boolean;
    points?: number | null;
    state: MembershipState;
    updatedUtc: string;
    program: { __typename?: 'Program' } & {
        ' $fragmentRefs'?: { LoyaltyProgramFieldsFragment: LoyaltyProgramFieldsFragment };
    };
    tier?:
        | ({ __typename?: 'Tier' } & { ' $fragmentRefs'?: { LoyaltyTierFieldsFragment: LoyaltyTierFieldsFragment } })
        | null;
} & { ' $fragmentName'?: 'LoyaltyMembershipSummaryFieldsFragment' };

export type GuestSummaryByIdResultQueryVariables = Exact<{
    guestId: Scalars['UUID']['input'];
}>;

export type GuestSummaryByIdResultQuery = {
    __typename?: 'Queries';
    guestSummaryById: {
        __typename?: 'GuestSummary';
        classifications: { __typename?: 'GuestProfileClassifications' } & {
            ' $fragmentRefs'?: { ClassificationFieldsFragment: ClassificationFieldsFragment };
        };
        loyaltyMemberships: Array<
            { __typename?: 'Membership' } & {
                ' $fragmentRefs'?: { LoyaltyMembershipSummaryFieldsFragment: LoyaltyMembershipSummaryFieldsFragment };
            }
        >;
        profile: { __typename?: 'GuestProfile' } & {
            ' $fragmentRefs'?: { GuestProfileBasicFieldsFragment: GuestProfileBasicFieldsFragment };
        };
        reservations: Array<
            { __typename?: 'ReservationSummary' } & {
                ' $fragmentRefs'?: { ReservationSummaryFieldsFragment: ReservationSummaryFieldsFragment };
            }
        >;
    };
};

export type DeclineMatchResultMutationVariables = Exact<{
    guest1Id: Scalars['UUID']['input'];
    guest2Id: Scalars['UUID']['input'];
}>;

export type DeclineMatchResultMutation = {
    __typename?: 'Mutations';
    declineMatch: { __typename?: 'DeclineMatchResult'; success: boolean };
};

export type MergeGuestProfilesResultMutationVariables = Exact<{
    sourceId: Scalars['UUID']['input'];
    targetId: Scalars['UUID']['input'];
    guestProfileDetails?: InputMaybe<GuestProfileMergeUpdatesInput>;
}>;

export type MergeGuestProfilesResultMutation = {
    __typename?: 'Mutations';
    mergeGuestProfiles: { __typename?: 'MergeResult'; success: boolean };
};

export type GuestProfileBasicFieldsFragment = {
    __typename?: 'GuestProfile';
    id: string;
    createdUtc: string;
    email?: string | null;
    firstName?: string | null;
    fullName: string;
    imageId?: string | null;
    lastName: string;
    phone?: string | null;
    updatedUtc: string;
    number: number;
    paymentCard?: { __typename?: 'PaymentCard'; lastDigits: string; type: PaymentCardType } | null;
} & { ' $fragmentName'?: 'GuestProfileBasicFieldsFragment' };

export type GuestProfileAdditionalFieldsFragment = {
    __typename?: 'GuestProfile';
    accountingCode?: string | null;
    billingCode?: string | null;
    birthDate?: string | null;
    birthPlace?: string | null;
    carRegistrationNumber?: string | null;
    loyaltyCode?: string | null;
    nationalityCode?: string | null;
    occupation?: string | null;
    preferredLanguageCode?: string | null;
    secondLastName?: string | null;
    sex?: Sex | null;
    taxIdentifier?: string | null;
    titlePrefix?: TitlePrefix | null;
    updatedUtc: string;
    loyaltyMembership?:
        | ({ __typename?: 'Membership' } & {
              ' $fragmentRefs'?: { LoyaltyMembershipBasicFieldsFragment: LoyaltyMembershipBasicFieldsFragment };
          })
        | null;
} & { ' $fragmentName'?: 'GuestProfileAdditionalFieldsFragment' };

export type GuestProfileFieldsFragment = ({ __typename?: 'GuestProfile' } & {
    ' $fragmentRefs'?: {
        GuestProfileBasicFieldsFragment: GuestProfileBasicFieldsFragment;
        GuestProfileAdditionalFieldsFragment: GuestProfileAdditionalFieldsFragment;
    };
}) & { ' $fragmentName'?: 'GuestProfileFieldsFragment' };

export type MatchedGuestProfilesResultQueryVariables = Exact<{
    chainId: Scalars['UUID']['input'];
    first?: InputMaybe<Scalars['Int']['input']>;
    after?: InputMaybe<Scalars['String']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
}>;

export type MatchedGuestProfilesResultQuery = {
    __typename?: 'Queries';
    matchedGuestProfiles?: {
        __typename?: 'MatchedGuestProfilesConnection';
        totalCount: number;
        edges?: Array<{
            __typename?: 'MatchedGuestProfilesEdge';
            cursor: string;
            node: { __typename?: 'GuestMatch'; id: string; guest1Id: string; guest2Id: string };
        }> | null;
        pageInfo: {
            __typename?: 'PageInfo';
            endCursor?: string | null;
            hasNextPage: boolean;
            hasPreviousPage: boolean;
            startCursor?: string | null;
        };
    } | null;
};

export type MatchedGuestProfilesByIdResultQueryVariables = Exact<{
    guestIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;

export type MatchedGuestProfilesByIdResultQuery = {
    __typename?: 'Queries';
    matchedGuestProfilesById: {
        __typename?: 'MatchedGuestProfiles';
        id: string;
        confidence: MatchConfidence;
        matchedFields: Array<MatchField>;
        mergeInfo: { __typename?: 'GuestMergeInfo'; isMergePossible: boolean; errorMessage: string };
        profiles: Array<
            { __typename?: 'GuestProfile' } & {
                ' $fragmentRefs'?: { GuestProfileFieldsFragment: GuestProfileFieldsFragment };
            }
        >;
        preSelectedFields: Array<{ __typename?: 'PreSelectedField'; field: DisplayField; profileId: string }>;
    };
};

export type NextMatchedGuestProfilesResultQueryVariables = Exact<{
    chainId: Scalars['UUID']['input'];
    previousMatchId?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type NextMatchedGuestProfilesResultQuery = {
    __typename?: 'Queries';
    nextMatchedGuestProfiles?: {
        __typename?: 'MatchedGuestProfiles';
        id: string;
        confidence: MatchConfidence;
        matchedFields: Array<MatchField>;
        mergeInfo: { __typename?: 'GuestMergeInfo'; isMergePossible: boolean; errorMessage: string };
        profiles: Array<
            { __typename?: 'GuestProfile' } & {
                ' $fragmentRefs'?: { GuestProfileFieldsFragment: GuestProfileFieldsFragment };
            }
        >;
        preSelectedFields: Array<{ __typename?: 'PreSelectedField'; field: DisplayField; profileId: string }>;
    } | null;
};

export type LoyaltyProgramFieldsFragment = {
    __typename?: 'Program';
    code: string;
    createdUtc: string;
    id: string;
    name: string;
    subscription: ProgramSubscription;
    type: ProgramType;
    updatedUtc: string;
    chainId: string;
} & { ' $fragmentName'?: 'LoyaltyProgramFieldsFragment' };

export type LoyaltyTierFieldsFragment = {
    __typename?: 'Tier';
    code: string;
    createdUtc: string;
    id: string;
    name: string;
    ordering: number;
    programId: string;
    updatedUtc: string;
} & { ' $fragmentName'?: 'LoyaltyTierFieldsFragment' };

export type GuestInsightsResultQueryVariables = Exact<{
    guestId: Scalars['UUID']['input'];
    currency: Scalars['String']['input'];
}>;

export type GuestInsightsResultQuery = {
    __typename?: 'Queries';
    guestSummaryById: {
        __typename?: 'GuestSummary';
        loyaltyMemberships: Array<
            { __typename?: 'Membership' } & {
                ' $fragmentRefs'?: { LoyaltyMembershipSummaryFieldsFragment: LoyaltyMembershipSummaryFieldsFragment };
            }
        >;
        analytics: {
            __typename?: 'Analytics';
            lastStayDate?: string | null;
            totalNightsSpent?: number | null;
            totalStays?: number | null;
            totalAmountSpent?: {
                __typename?: 'Amount';
                currencyCode: string;
                grossAmount?: any | null;
                netAmount: any;
            } | null;
        };
    };
};

export type GuestTotalStaysByIdsResultQueryVariables = Exact<{
    guestIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;

export type GuestTotalStaysByIdsResultQuery = {
    __typename?: 'Queries';
    guestSummaryByIds: Array<{
        __typename?: 'GuestSummary';
        guestId: string;
        analytics: { __typename?: 'Analytics'; totalStays?: number | null };
    } | null>;
};

export type GuestSummaryAnalyticsResultQueryVariables = Exact<{
    guestId: Scalars['UUID']['input'];
    currency: Scalars['String']['input'];
}>;

export type GuestSummaryAnalyticsResultQuery = {
    __typename?: 'Queries';
    guestSummaryById: {
        __typename?: 'GuestSummary';
        analytics: {
            __typename?: 'Analytics';
            lastStayDate?: string | null;
            totalNightsSpent?: number | null;
            totalStays?: number | null;
            totalAmountSpent?: {
                __typename?: 'Amount';
                currencyCode: string;
                grossAmount?: any | null;
                netAmount: any;
            } | null;
        };
    };
};

export type DeleteIdentityDocumentPhotoMutationVariables = Exact<{
    id: Scalars['UUID']['input'];
    identityDocumentId: Scalars['UUID']['input'];
    guestId: Scalars['UUID']['input'];
}>;

export type DeleteIdentityDocumentPhotoMutation = {
    __typename?: 'Mutations';
    deleteIdentityDocumentPhoto: { __typename?: 'DeleteIdentityDocumentPhotoResult'; success: boolean };
};

export type AddGuestRelationResultMutationVariables = Exact<{
    guestId: Scalars['UUID']['input'];
    relatedGuestId: Scalars['UUID']['input'];
    relationship: GuestRelationship;
}>;

export type AddGuestRelationResultMutation = {
    __typename?: 'Mutations';
    addGuestRelation: { __typename?: 'AddGuestRelationResult'; success: boolean };
};

export type RemoveGuestRelationMutationVariables = Exact<{
    id: Scalars['UUID']['input'];
}>;

export type RemoveGuestRelationMutation = {
    __typename?: 'Mutations';
    removeGuestRelation: { __typename?: 'RemoveGuestRelationResult'; success: boolean };
};

export type UpdateGuestRelationResultMutationVariables = Exact<{
    id: Scalars['UUID']['input'];
    relationship: GuestRelationship;
}>;

export type UpdateGuestRelationResultMutation = {
    __typename?: 'Mutations';
    updateGuestRelation: { __typename?: 'UpdateGuestRelationResult'; success: boolean };
};

export type GuestSummaryByIdsResultQueryVariables = Exact<{
    guestIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;

export type GuestSummaryByIdsResultQuery = {
    __typename?: 'Queries';
    guestSummaryByIds: Array<{
        __typename?: 'GuestSummary';
        analytics: { __typename?: 'Analytics'; totalStays?: number | null };
    } | null>;
};

export type GuestRelationshipsResultQueryVariables = Exact<{
    guestId: Scalars['UUID']['input'];
}>;

export type GuestRelationshipsResultQuery = {
    __typename?: 'Queries';
    guestRelationships: {
        __typename?: 'GuestRelationships';
        guest: {
            __typename?: 'GuestProfile';
            fullName: string;
            createdUtc: string;
            id: string;
            lastName: string;
            number: number;
            updatedUtc: string;
        };
        relatedGuests: Array<{
            __typename: 'RelatedGuestDetails';
            fullName: string;
            guestId: string;
            id: string;
            relationship: GuestRelationship;
            nextStayDate?: string | null;
            nextStayReservationId?: string | null;
            previousStayCount: number;
            source: GuestRelationshipSource;
        }>;
        suggestedRelations: Array<{
            __typename: 'SuggestedRelation';
            fullName: string;
            guestId: string;
            nextStayDate?: string | null;
            previousStayCount: number;
        }>;
    };
};

export type DeleteGuestPhotoResultMutationVariables = Exact<{
    guestId: Scalars['UUID']['input'];
    photoId: Scalars['UUID']['input'];
}>;

export type DeleteGuestPhotoResultMutation = {
    __typename?: 'Mutations';
    deleteGuestPhoto: { __typename?: 'DeleteGuestPhotoResult'; success: boolean };
};

export type GuestPhotosResultQueryVariables = Exact<{
    guestIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;

export type GuestPhotosResultQuery = {
    __typename?: 'Queries';
    guestPhotos: Array<{
        __typename?: 'GuestPhoto';
        id: string;
        createdUtc: string;
        guestId: string;
        name: string;
        imageUrl: string;
    }>;
};

export type TotalProfileMatchesQueryVariables = Exact<{
    chainId: Scalars['UUID']['input'];
}>;

export type TotalProfileMatchesQuery = {
    __typename?: 'Queries';
    totalProfileMatches: { __typename?: 'TotalProfileMatches'; total: number };
};

export const ClassificationFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ClassificationFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GuestProfileClassifications' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'airline' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'blacklist' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'cashlist' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'disabledPerson' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'friendOrFamily' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'healthCompliant' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'important' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'inRoom' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'loyaltyProgram' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'media' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'military' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'paymasterAccount' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'previousComplaint' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'problematic' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'returning' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'staff' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'student' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'topManagement' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'veryImportant' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'waitingForRoom' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<ClassificationFieldsFragment, unknown>;
export const ReservationSummaryFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ReservationSummaryFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ReservationSummary' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'accountState' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'endUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'groupName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'serviceId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'reservationState' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'serviceOrderState' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'startLocalTime' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'endLocalTime' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'startUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'timeState' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'options' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'allCompanionsCheckedIn' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'anyCompanionCheckedIn' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'ownerCheckedIn' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'ownerCheckedOut' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'skipCleaning' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resource' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<ReservationSummaryFieldsFragment, unknown>;
export const LoyaltyProgramFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'LoyaltyProgramFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Program' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'subscription' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'chainId' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<LoyaltyProgramFieldsFragment, unknown>;
export const LoyaltyTierFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'LoyaltyTierFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Tier' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'ordering' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'programId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedUtc' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<LoyaltyTierFieldsFragment, unknown>;
export const LoyaltyMembershipSummaryFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'LoyaltyMembershipSummaryFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Membership' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isPrimary' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'points' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedUtc' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'program' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'LoyaltyProgramFields' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tier' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'LoyaltyTierFields' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'LoyaltyProgramFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Program' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'subscription' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'chainId' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'LoyaltyTierFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Tier' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'ordering' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'programId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedUtc' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<LoyaltyMembershipSummaryFieldsFragment, unknown>;
export const GuestProfileBasicFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GuestProfileBasicFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GuestProfile' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'imageId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentCard' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'lastDigits' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GuestProfileBasicFieldsFragment, unknown>;
export const LoyaltyMembershipBasicFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'LoyaltyMembershipBasicFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Membership' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isPrimary' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedUtc' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'program' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'LoyaltyProgramFields' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'LoyaltyProgramFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Program' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'subscription' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'chainId' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<LoyaltyMembershipBasicFieldsFragment, unknown>;
export const GuestProfileAdditionalFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GuestProfileAdditionalFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GuestProfile' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'accountingCode' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'billingCode' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'birthPlace' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'carRegistrationNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'loyaltyCode' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'loyaltyMembership' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'LoyaltyMembershipBasicFields' },
                                },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'nationalityCode' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'occupation' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'preferredLanguageCode' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'secondLastName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'sex' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'taxIdentifier' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'titlePrefix' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedUtc' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'LoyaltyProgramFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Program' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'subscription' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'chainId' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'LoyaltyMembershipBasicFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Membership' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isPrimary' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedUtc' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'program' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'LoyaltyProgramFields' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GuestProfileAdditionalFieldsFragment, unknown>;
export const GuestProfileFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GuestProfileFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GuestProfile' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GuestProfileBasicFields' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GuestProfileAdditionalFields' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'LoyaltyProgramFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Program' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'subscription' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'chainId' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'LoyaltyMembershipBasicFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Membership' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isPrimary' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedUtc' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'program' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'LoyaltyProgramFields' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GuestProfileBasicFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GuestProfile' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'imageId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentCard' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'lastDigits' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GuestProfileAdditionalFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GuestProfile' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'accountingCode' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'billingCode' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'birthPlace' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'carRegistrationNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'loyaltyCode' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'loyaltyMembership' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'LoyaltyMembershipBasicFields' },
                                },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'nationalityCode' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'occupation' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'preferredLanguageCode' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'secondLastName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'sex' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'taxIdentifier' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'titlePrefix' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedUtc' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GuestProfileFieldsFragment, unknown>;
export const GuestSummaryByIdResultDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'guestSummaryByIdResult' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'guestId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'guestSummaryById' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'guestId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'guestId' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'classifications' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'ClassificationFields' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'loyaltyMemberships' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'LoyaltyMembershipSummaryFields' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'profile' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'GuestProfileBasicFields' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'reservations' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'ReservationSummaryFields' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'LoyaltyProgramFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Program' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'subscription' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'chainId' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'LoyaltyTierFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Tier' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'ordering' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'programId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedUtc' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ClassificationFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GuestProfileClassifications' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'airline' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'blacklist' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'cashlist' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'disabledPerson' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'friendOrFamily' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'healthCompliant' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'important' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'inRoom' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'loyaltyProgram' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'media' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'military' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'paymasterAccount' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'previousComplaint' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'problematic' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'returning' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'staff' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'student' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'topManagement' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'veryImportant' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'waitingForRoom' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'LoyaltyMembershipSummaryFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Membership' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isPrimary' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'points' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedUtc' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'program' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'LoyaltyProgramFields' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tier' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'LoyaltyTierFields' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GuestProfileBasicFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GuestProfile' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'imageId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentCard' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'lastDigits' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ReservationSummaryFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ReservationSummary' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'accountState' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'endUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'groupName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'serviceId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'reservationState' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'serviceOrderState' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'startLocalTime' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'endLocalTime' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'startUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'timeState' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'options' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'allCompanionsCheckedIn' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'anyCompanionCheckedIn' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'ownerCheckedIn' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'ownerCheckedOut' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'skipCleaning' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resource' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GuestSummaryByIdResultQuery, GuestSummaryByIdResultQueryVariables>;
export const DeclineMatchResultDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'declineMatchResult' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'guest1Id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'guest2Id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'declineMatch' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'guest1Id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'guest1Id' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'guest2Id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'guest2Id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'success' } }],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<DeclineMatchResultMutation, DeclineMatchResultMutationVariables>;
export const MergeGuestProfilesResultDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'mergeGuestProfilesResult' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'sourceId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'targetId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'guestProfileDetails' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'GuestProfileMergeUpdatesInput' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mergeGuestProfiles' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'sourceId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'sourceId' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'targetId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'targetId' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'guestProfileDetails' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'guestProfileDetails' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'success' } }],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<MergeGuestProfilesResultMutation, MergeGuestProfilesResultMutationVariables>;
export const MatchedGuestProfilesResultDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'MatchedGuestProfilesResult' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'chainId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'matchedGuestProfiles' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'chainId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'chainId' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'first' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'after' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'last' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'before' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'cursor' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'node' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'guest1Id' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'guest2Id' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pageInfo' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<MatchedGuestProfilesResultQuery, MatchedGuestProfilesResultQueryVariables>;
export const MatchedGuestProfilesByIdResultDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'matchedGuestProfilesByIdResult' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'guestIds' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'ListType',
                            type: {
                                kind: 'NonNullType',
                                type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'matchedGuestProfilesById' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'guestIds' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'guestIds' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'confidence' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'matchedFields' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'mergeInfo' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'isMergePossible' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'profiles' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'GuestProfileFields' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'preSelectedFields' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'profileId' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GuestProfileBasicFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GuestProfile' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'imageId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentCard' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'lastDigits' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'LoyaltyProgramFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Program' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'subscription' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'chainId' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'LoyaltyMembershipBasicFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Membership' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isPrimary' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedUtc' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'program' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'LoyaltyProgramFields' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GuestProfileAdditionalFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GuestProfile' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'accountingCode' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'billingCode' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'birthPlace' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'carRegistrationNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'loyaltyCode' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'loyaltyMembership' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'LoyaltyMembershipBasicFields' },
                                },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'nationalityCode' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'occupation' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'preferredLanguageCode' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'secondLastName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'sex' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'taxIdentifier' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'titlePrefix' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedUtc' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GuestProfileFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GuestProfile' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GuestProfileBasicFields' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GuestProfileAdditionalFields' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<MatchedGuestProfilesByIdResultQuery, MatchedGuestProfilesByIdResultQueryVariables>;
export const NextMatchedGuestProfilesResultDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'nextMatchedGuestProfilesResult' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'chainId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'previousMatchId' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nextMatchedGuestProfiles' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'chainId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'chainId' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'previousMatchId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'previousMatchId' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'confidence' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'matchedFields' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'mergeInfo' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'isMergePossible' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'profiles' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'GuestProfileFields' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'preSelectedFields' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'profileId' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GuestProfileBasicFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GuestProfile' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'imageId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentCard' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'lastDigits' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'LoyaltyProgramFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Program' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'subscription' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'chainId' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'LoyaltyMembershipBasicFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Membership' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isPrimary' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedUtc' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'program' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'LoyaltyProgramFields' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GuestProfileAdditionalFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GuestProfile' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'accountingCode' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'billingCode' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'birthPlace' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'carRegistrationNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'loyaltyCode' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'loyaltyMembership' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'LoyaltyMembershipBasicFields' },
                                },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'nationalityCode' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'occupation' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'preferredLanguageCode' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'secondLastName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'sex' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'taxIdentifier' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'titlePrefix' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedUtc' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GuestProfileFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GuestProfile' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GuestProfileBasicFields' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GuestProfileAdditionalFields' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<NextMatchedGuestProfilesResultQuery, NextMatchedGuestProfilesResultQueryVariables>;
export const GuestInsightsResultDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'guestInsightsResult' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'guestId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'currency' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'guestSummaryById' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'guestId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'guestId' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'loyaltyMemberships' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'LoyaltyMembershipSummaryFields' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'analytics' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'lastStayDate' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'totalAmountSpent' },
                                                arguments: [
                                                    {
                                                        kind: 'Argument',
                                                        name: { kind: 'Name', value: 'currency' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'currency' },
                                                        },
                                                    },
                                                ],
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'currencyCode' },
                                                        },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'grossAmount' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'totalNightsSpent' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'totalStays' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'LoyaltyProgramFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Program' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'subscription' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'chainId' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'LoyaltyTierFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Tier' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'ordering' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'programId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedUtc' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'LoyaltyMembershipSummaryFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Membership' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdUtc' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isPrimary' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'points' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedUtc' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'program' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'LoyaltyProgramFields' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tier' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'LoyaltyTierFields' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GuestInsightsResultQuery, GuestInsightsResultQueryVariables>;
export const GuestTotalStaysByIdsResultDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GuestTotalStaysByIdsResult' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'guestIds' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'ListType',
                            type: {
                                kind: 'NonNullType',
                                type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'guestSummaryByIds' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'guestIds' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'guestIds' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'guestId' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'analytics' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'totalStays' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GuestTotalStaysByIdsResultQuery, GuestTotalStaysByIdsResultQueryVariables>;
export const GuestSummaryAnalyticsResultDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'guestSummaryAnalyticsResult' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'guestId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'currency' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'guestSummaryById' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'guestId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'guestId' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'analytics' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'lastStayDate' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'totalAmountSpent' },
                                                arguments: [
                                                    {
                                                        kind: 'Argument',
                                                        name: { kind: 'Name', value: 'currency' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'currency' },
                                                        },
                                                    },
                                                ],
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'currencyCode' },
                                                        },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'grossAmount' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'totalNightsSpent' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'totalStays' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GuestSummaryAnalyticsResultQuery, GuestSummaryAnalyticsResultQueryVariables>;
export const DeleteIdentityDocumentPhotoDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'deleteIdentityDocumentPhoto' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'identityDocumentId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'guestId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deleteIdentityDocumentPhoto' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'identityDocumentId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'identityDocumentId' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'guestId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'guestId' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'success' } }],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<DeleteIdentityDocumentPhotoMutation, DeleteIdentityDocumentPhotoMutationVariables>;
export const AddGuestRelationResultDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'addGuestRelationResult' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'guestId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'relatedGuestId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'relationship' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'GuestRelationship' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'addGuestRelation' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'guestId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'guestId' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'relatedGuestId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'relatedGuestId' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'relationship' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'relationship' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'success' } }],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<AddGuestRelationResultMutation, AddGuestRelationResultMutationVariables>;
export const RemoveGuestRelationDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'removeGuestRelation' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'removeGuestRelation' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'success' } }],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<RemoveGuestRelationMutation, RemoveGuestRelationMutationVariables>;
export const UpdateGuestRelationResultDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'updateGuestRelationResult' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'relationship' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'GuestRelationship' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updateGuestRelation' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'relationship' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'relationship' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'success' } }],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<UpdateGuestRelationResultMutation, UpdateGuestRelationResultMutationVariables>;
export const GuestSummaryByIdsResultDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GuestSummaryByIdsResult' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'guestIds' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'ListType',
                            type: {
                                kind: 'NonNullType',
                                type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'guestSummaryByIds' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'guestIds' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'guestIds' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'analytics' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'totalStays' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GuestSummaryByIdsResultQuery, GuestSummaryByIdsResultQueryVariables>;
export const GuestRelationshipsResultDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GuestRelationshipsResult' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'guestId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'guestRelationships' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'guestId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'guestId' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'guest' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'createdUtc' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'updatedUtc' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'relatedGuests' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'guestId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'relationship' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'nextStayDate' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'nextStayReservationId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'previousStayCount' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'suggestedRelations' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'guestId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'nextStayDate' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'previousStayCount' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GuestRelationshipsResultQuery, GuestRelationshipsResultQueryVariables>;
export const DeleteGuestPhotoResultDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'deleteGuestPhotoResult' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'guestId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'photoId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deleteGuestPhoto' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'guestId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'guestId' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'photoId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'photoId' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'success' } }],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<DeleteGuestPhotoResultMutation, DeleteGuestPhotoResultMutationVariables>;
export const GuestPhotosResultDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'guestPhotosResult' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'guestIds' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'ListType',
                            type: {
                                kind: 'NonNullType',
                                type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'guestPhotos' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'guestIds' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'guestIds' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdUtc' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'guestId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GuestPhotosResultQuery, GuestPhotosResultQueryVariables>;
export const TotalProfileMatchesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'totalProfileMatches' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'chainId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalProfileMatches' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'chainId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'chainId' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<TotalProfileMatchesQuery, TotalProfileMatchesQueryVariables>;
